<template>
  <div class="container noGymsFoundContainer">
    <div class="columns is-vcentered is-gapless">
      <div class="column is-hidden-mobile">
        <figure class="image">
          <img
            class="desktopLogo"
            :src="require('@/assets/images/PNG/MyGymChecker-Logomark-PNG-BlackBlue.png')"
          />
        </figure>
      </div>
      <div class="column is-two-thirds has-text-centered">
        <div>
          <p class="title">Computer says: &quot;Noooo..&quot;</p>
          <p class="title">Sorry, we have no gyms in this location yet!</p>
        </div>
        <div class="button-wrapper">
          <router-link to="/register" class="button is-rounded search-button is-large">Sign up here!</router-link>
        </div>
      </div>
      <div class="column">
        <figure class="image">
          <img
            class="desktopLogo"
            :src="require('@/assets/images/PNG/MyGymChecker-Logomark-PNG-BlackBlue.png')"
          />
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.minh10rem {
  min-height: 10rem;
}

.button-wrapper {
  text-align: center;
  margin: 1rem auto;
}

.noGymsFoundContainer {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 768px) {
  .noGymsFoundContainer {
    margin: 2rem;
  }
}
</style>
